import { IKvkType } from 'affiny-core/modules/api/models/account/account.types';

export interface IApiMember {
  type: 'member';
  id: string;
  attributes: {
    nickname: string;
    birthdate: string;
    kvk: IKvkType;
    registrationDate: string;
    isBlacklisted: boolean;
    geo: {
      city: {
        id: string;
        name: string;
        latitude: number;
        longitude: number;
      };
      region: { id: string; name: string };
      country: { isocode: string; name: string };
    };
    privacy: { privatePicture: boolean };
  };
}

export interface IApiMemberProfileIncludedAnnounce {
  type: EIncludedType.ANNOUNCE;
  id: string;
  attributes: {
    type: string;
    text: string;
    valid: boolean;
  };
}

interface IApiMemberProfileIncludedFavorite {
  type: EIncludedType.FAVORITE;
  id: string;
  attributes: {
    value: string;
  };
}

export interface IApiMemberProfileIncludedScore {
  type: EIncludedType.SCORE;
  id: string;
  attributes: {
    score: number;
  };
}

export interface IApiMemberBlacklistIncluded {
  type: EIncludedType.BLACKLIST;
  id: string;
  attributes: {
    isBlacklisted: boolean;
  };
}

export interface IApiMemberScoreIncluded {
  type: EIncludedType.SCORE;
  id: string;
  attributes: {
    score: number;
  };
}

export enum EPhotoRevealStatus {
  PENDING = 'pending',
  AVAILABLE = 'available',
  ACCEPTED = 'accepted',
  NOT_APPLICABLE = 'not_applicable',
}

interface IApiMemberProfileIncludedPhotoRevealStatus {
  type: EIncludedType.PHOTO_REVEAL_STATUS;
  id: string;
  attributes: {
    value: EPhotoRevealStatus;
  };
}

export enum EIncludedType {
  MEMBER = 'member',
  ANNOUNCE = 'announce',
  PHOTO_REVEAL_STATUS = 'photoRevealStatus',
  FAVORITE = 'favorite',
  SCORE = 'score',
  BLACKLIST = 'blacklist',
  LAST_CONNECTION = 'lastConnection',
}

interface IRelationship {
  data: {
    type: string;
    id: string;
  } | null;
}

export interface IRelationships {
  announce?: IRelationship;
  blacklist?: IRelationship;
  photoRevealStatus?: IRelationship;
  favorite?: {
    data: {
      type: string;
      id: string;
    } | null;
  };
}

export interface IApiMemberProfileAttributes extends IApiMember {
  relationships?: IRelationships;
}

export interface IApiCompatibilityReportLight {
  type: string;
  id: string;
  attributes: {
    similarities: string[];
    complementarities: string[];
  };
}

export interface IPosition {
  x?: number;
  y?: number;
}
export interface IRawMatrix {
  dimension: 1 | 2;
  viewer: IPosition;
  viewee: IPosition;
  left_top_label_key?: string;
  right_top_label_key?: string;
  left_bottom_label_key?: string;
  right_bottom_label_key?: string;
  left_label_key?: string;
  right_label_key?: string;
  top_label_key?: string;
  bottom_label_key?: string;
}
export interface IRawGraph {
  id: string;
  matrices: IRawMatrix[];
  analysis: string[];
}

export enum ECompatibilityReportType {
  VALUE = 'value',
  VISION = 'vision',
  PERSONALITY = 'personality',
}

export interface IRawApiCompatibilityReport {
  data: {
    type: 'report_full';
    id: string;
    attributes: {
      graphes: IRawGraph[];
      analysis: string[];
    };
  };
}

export interface IApiLastConnection {
  id: string;
  type: 'lastConnection';
  attributes: {
    last_connection_date: string;
  };
}

export type TApiIncludedTypes =
  | IApiMemberProfileIncludedAnnounce
  | IApiMemberProfileIncludedFavorite
  | IApiMemberProfileIncludedPhotoRevealStatus
  | IApiMemberProfileIncludedScore
  | IApiMemberBlacklistIncluded
  | IApiLastConnection;

export type TApiIncluded = TApiIncludedTypes[];

export interface IApiMemberProfile {
  data: IApiMemberProfileAttributes;
  included?: TApiIncluded;
}
